import { render, staticRenderFns } from "./updateBusiness.vue?vue&type=template&id=c716ec74&scoped=true"
import script from "./updateBusiness.vue?vue&type=script&lang=js"
export * from "./updateBusiness.vue?vue&type=script&lang=js"
import style0 from "./updateBusiness.vue?vue&type=style&index=0&id=c716ec74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c716ec74",
  null
  
)

export default component.exports